import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.loadDocumentTypes()
  }

  async loadDocumentTypes() {
    try {
      const response = await fetch(this.urlValue)
      const data = await response.json()

      // Clear existing options except the first one
      this.element.innerHTML = '<option value="">Select document type...</option>'

      // Add document types
      data.document_types.forEach(docType => {
        const option = document.createElement('option')
        option.value = docType.id
        option.textContent = docType.name
        if (docType.description) {
          option.title = docType.description
        }
        this.element.appendChild(option)
      })

    } catch (error) {
      console.error('Error loading document types:', error)
      this.element.innerHTML = '<option value="">Error loading document types</option>'
    }
  }
}